import _ from 'lodash'
import api from '../api'
import * as types from '../types'
import config from './../../config'

export default {
  state: {
    contractImageSrc: config.contractImageSrc,
    contractImageSrcBl: config.contractImageSrcBl,
    contract: {
      show: false,
      content: ''
    }
  },
  getters: {
    [types.GET_CONTRACT_IMAGE_SRC]: state => state.contractImageSrc,
    [types.GET_CONTRACT_IMAGE_SRC_BL]: state => state.contractImageSrcBl,
    [types.GET_CONTRACT]: state => state.contract
  },
  actions: {
    [types.SET_REGISTER_CONTRACT] ({dispatch, commit}) {
      api.registerContract().then((res) => {
        const resData = res.data

        if (Number(resData.code) === 0) {
          commit(types.SET_CONTRACT_STATE, {
            title: '注册须知',
            show: false,
            content: resData.registerContract
          })
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: false,
            content: '注册协议获取失败'
          })
          return res
        }
      })
    },  
    [types.USER_REGISTER] ({dispatch}, params) {
      return api.userRegister(params).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          return dispatch(types.USER_LOGIN, {
            loginName: params.customerLoginName,
            password: params.customerLoginPwd
          })
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '注册失败'
          })
          return res
        }
      })
    },
    [types.USER_LOGIN] ({dispatch, commit}, params) {
      return api.userLogin({
        loginName: params.loginName,
        password: params.password
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          commit(types.SET_USER, resData.data)
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '登录失败'
          })
        }
        return res
      })
    },
    [types.USER_LOGOUT] ({dispatch, commit}, params) {
      api.userLogout().then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          localStorage.removeItem( "dl_tokenId_bl" );
          commit(types.SET_USER, {})
          params.router.push('/')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '注销失败'
          })
        }
      })
    },
    [types.FORGET_PASSWORD] ({dispatch}, params) {
      return api.forgetPassword({
        mobile: params.mobile,
        validCode: params.validCode,
        password: params.password,
        confirmPassword: params.confirmPassword
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          dispatch(types.SET_SUCCESS_MESSAGE, {
            show: true,
            content: resData.result
          })
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result || '新密码设置失败'
          })
        }
        return res
      })
    }
  },
  mutations: {
    [types.SET_CONTRACT_STATE] (state, data) {
      // debugger
      state.contract = {
        title: _.isEmpty(data.title) ? state.contract.title : data.title,
        show: data.show,
        content: _.isEmpty(data.content) ? state.contract.content : data.content
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js